import type {
  Client,
  Place,
  Project,
  Variable,
  User,
  ProjectEnergy,
} from "@/types";
import type { ParameterState } from "@/types/store";
import type { MutationTree } from "vuex";

// ROLES
export const LOAD_ROLES = "LOAD_ROLES";
export const LOAD_ROLES_SUCCESS = "LOAD_ROLES_SUCCESS";
export const LOAD_ROLES_FAILURE = "LOAD_ROLES_FAILURE";

export const UPDATE_ROLES = "UPDATE_ROLES";
export const UPDATE_ROLES_SUCCESS = "UPDATE_ROLES_SUCCESS";
export const UPDATE_ROLES_FAILURE = "UPDATE_ROLES_FAILURE";

// PERMISSIONS
export const LOAD_PERMISSIONS = "LOAD_PERMISSIONS";
export const LOAD_PERMISSIONS_SUCCESS = "LOAD_PERMISSIONS_SUCCESS";
export const LOAD_PERMISSIONS_FAILURE = "LOAD_PERMISSIONS_FAILURE";

// USERS
export const LOAD_USERS = "LOAD_USERS";
export const LOAD_USERS_SUCCESS = "LOAD_USERS_SUCCESS";
export const LOAD_USERS_FAILURE = "LOAD_USERS_FAILURE";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";

export const ADD_USER_FAILURE = "ADD_USER_FAILURE";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";
export const UPDATE_ONE_USER_SUCCESS = "UPDATE_ONE_USER_SUCCESS";

// USER
export const LOAD_USER = "LOAD_USER";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_FAILURE = "LOAD_USER_FAILURE";

export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";
export const UPDATE_ONE_USER_FAILURE = "UPDATE_ONE_USER_FAILURE";

// CLIENTS
export const LOAD_CLIENTS = "LOAD_CLIENTS";
export const LOAD_CLIENTS_SUCCESS = "LOAD_CLIENTS_SUCCESS";
export const LOAD_CLIENTS_FAILURE = "LOAD_CLIENTS_FAILURE";

export const LOAD_CLIENT = "LOAD_CLIENT";
export const LOAD_CLIENT_SUCCESS = "LOAD_CLIENT_SUCCESS";
export const LOAD_CLIENT_FAILURE = "LOAD_CLIENT_FAILURE";

export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const UPDATE_CLIENT_SUCCESS = "UPDATE_CLIENT_SUCCESS";
export const UPDATE_CLIENT_FAILURE = "UPDATE_CLIENT_FAILURE";

// PLACES
export const LOAD_PLACES = "LOAD_PLACES";
export const LOAD_PLACES_SUCCESS = "LOAD_PLACES_SUCCESS";
export const LOAD_PLACES_FAILURE = "LOAD_PLACES_FAILURE";

export const LOAD_PLACE = "LOAD_PLACE";
export const LOAD_PLACE_SUCCESS = "LOAD_PLACE_SUCCESS";
export const LOAD_PLACE_FAILURE = "LOAD_PLACE_FAILURE";

export const UPDATE_PLACE = "UPDATE_PLACE";
export const UPDATE_PLACE_SUCCESS = "UPDATE_PLACE_SUCCESS";
export const UPDATE_PLACE_FAILURE = "UPDATE_PLACE_FAILURE";

// PROJECTS
export const LOAD_ALL_PROJECTS = "LOAD_ALL_PROJECTS";
export const LOAD_ALL_PROJECTS_SUCCESS = "LOAD_ALL_PROJECTS_SUCCESS";
export const LOAD_ALL_PROJECTS_FAILURE = "LOAD_ALL_PROJECTS_FAILURE";

export const LOAD_PROJECTS = "LOAD_PROJECTS";
export const LOAD_PROJECTS_SUCCESS = "LOAD_PROJECTS_SUCCESS";
export const LOAD_PROJECTS_FAILURE = "LOAD_PROJECTS_FAILURE";

export const LOAD_PROJECT = "LOAD_PROJECT";
export const LOAD_PROJECT_SUCCESS = "LOAD_PROJECT_SUCCESS";
export const LOAD_PROJECT_FAILURE = "LOAD_PROJECT_FAILURE";

export const ADD_PROJECT = "ADD_PROJECT";
export const ADD_PROJECT_SUCCESS = "ADD_PROJECT_SUCCESS";
export const ADD_PROJECT_FAILURE = "ADD_PROJECT_FAILURE";

export const EDIT_PROJECT = "EDIT_PROJECT";
export const EDIT_PROJECT_SUCCESS = "EDIT_PROJECT_SUCCESS";
export const EDIT_PROJECT_FAILURE = "EDIT_PROJECT_FAILURE";

// BEX SUPPORT

export const LOAD_BEX_SUPPORT = "LOAD_BEX_SUPPORT";
export const LOAD_BEX_SUPPORT_SUCCESS = "LOAD_BEX_SUPPORT_SUCCESS";
export const LOAD_BEX_SUPPORT_FAILURE = "LOAD_BEX_SUPPORT_FAILURE";

export const LOAD_BEX_SUPPORT_FILES = "LOAD_BEX_SUPPORT_FILES";
export const LOAD_BEX_SUPPORT_FILES_SUCCESS = "LOAD_BEX_SUPPORT_FILES_SUCCESS";
export const LOAD_BEX_SUPPORT_FILES_FAILURE = "LOAD_BEX_SUPPORT_FILES_FAILURE";

export const LOAD_CHOICES_BEX_SUPPORT = "LOAD_CHOICES_BEX_SUPPORT";
export const LOAD_CHOICES_BEX_SUPPORT_SUCCESS =
  "LOAD_CHOICES_BEX_SUPPORT_SUCCESS";
export const LOAD_CHOICES_BEX_SUPPORT_FAILURE =
  "LOAD_CHOICES_BEX_SUPPORT_FAILURE";
// PROJECTS Energy

export const LOAD_PROJECT_ENERGIES = "LOAD_PROJECT_ENERGIES";
export const LOAD_PROJECT_ENERGIES_SUCCESS = "LOAD_PROJECT_ENERGIES_SUCCESS";
export const LOAD_PROJECT_ENERGIES_FAILURE = "LOAD_PROJECT_ENERGIES_FAILURE";

export const DELETE_BILAN = "DELETE_BILAN";
export const DELETE_BILAN_SUCCESS = "DELETE_BILAN_SUCCESS";
export const DELETE_BILAN_FAILURE = "DELETE_BILAN_FAILURE";
// Variables
export const LOAD_VARIABLES = "LOAD_VARIABLES";
export const LOAD_VARIABLES_SUCCESS = "LOAD_VARIABLES_SUCCESS";
export const LOAD_VARIABLES_FAILURE = "LOAD_VARIABLES_FAILURE";

// Variable relation
export const LOAD_VARIABLE_RELATION = "LOAD_VARIABLE_RELATION";
export const LOAD_VARIABLE_RELATION_SUCCESS = "LOAD_VARIABLE_RELATION_SUCCESS";
export const LOAD_VARIABLE_RELATION_FAILURE = "LOAD_VARIABLE_RELATION_FAILURE";

// Variable

export const LOAD_VARIABLE = "LOAD_VARIABLE";
export const LOAD_VARIABLE_SUCCESS = "LOAD_VARIABLE_SUCCESS";
export const LOAD_VARIABLE_FAILURE = "LOAD_VARIABLE_FAILURE";
export const CLEAR_VARIABLE = "CLEAR_VARIABLE";

export const EDIT_VARIABLE = "EDIT_VARIABLE";
export const EDIT_VARIABLE_SUCCESS = "EDIT_VARIABLE_SUCCESS";
export const EDIT_VARIABLE_FAILURE = "EDIT_VARIABLE_FAILURE";

// Projet energy
export const LOAD_CHOICES = "LOAD_CHOICES";
export const LOAD_CHOICES_SUCCESS = "LOAD_CHOICES_SUCCESS";
export const LOAD_CHOICES_FAILURE = "LOAD_CHOICES_FAILURE";

// AAPE

export const LOAD_AAPES = "LOAD_AAPES";
export const LOAD_AAPES_SUCCESS = "LOAD_AAPES_SUCCESS";
export const LOAD_AAPES_FAILURE = "LOAD_AAPES_FAILURE";

export const LOAD_AAPES_DETAIL_SUCCESS = "LOAD_AAPES_DETAIL_SUCCESS";
export const LOAD_AAPES_DETAIL_FAILURE = "LOAD_AAPES_DETAIL_FAILURE";

export const ADD_AAPE = "ADD_AAPE";
export const ADD_AAPE_SUCCESS = "ADD_AAPE_SUCCESS";
export const ADD_AAPE_FAILURE = "ADD_AAPE_FAILURE";

export const EDIT_AAPE = "EDIT_AAPE";
export const EDIT_AAPE_SUCCESS = "EDIT_AAPE_SUCCESS";
export const EDIT_AAPE_FAILURE = "EDIT_AAPE_FAILURE";

export const DELETE_AAPE = "DELETE_AAPE";
export const DELETE_AAPE_SUCCESS = "DELETE_AAPE_SUCCESS";
export const DELETE_AAPE_FAILURE = "DELETE_AAPE_FAILURE";

export const CLEAR_AAPES = "CLEAR_AAPES";

// PERIMETER

export const LOAD_PERIMETERS = "LOAD_PERIMETERS";
export const LOAD_PERIMETERS_SUCCESS = "LOAD_PERIMETERS_SUCCESS";
export const LOAD_PERIMETERS_FAILURE = "LOAD_PERIMETERS_FAILURE";

export const ADD_PERIMETER = "ADD_PERIMETER";
export const ADD_PERIMETER_SUCCESS = "ADD_PERIMETER_SUCCESS";
export const ADD_PERIMETER_FAILURE = "ADD_PERIMETER_FAILURE";

export const EDIT_PERIMETER = "EDIT_PERIMETER";
export const EDIT_PERIMETER_SUCCESS = "EDIT_PERIMETER_SUCCESS";
export const EDIT_PERIMETER_FAILURE = "EDIT_PERIMETER_FAILURE";

export const DELETE_PERIMETER = "DELETE_PERIMETER";
export const DELETE_PERIMETER_SUCCESS = "DELETE_PERIMETER_SUCCESS";
export const DELETE_PERIMETER_FAILURE = "DELETE_PERIMETER_FAILURE";

export const CLEAR_PERIMETERS = "CLEAR_PERIMETERS";

// BILANS

export const LOAD_BILANS = "LOAD_BILANS";
export const LOAD_BILANS_SUCCESS = "LOAD_BILANS_SUCCESS";
export const LOAD_BILANS_PERIMETERS_SUCCESS = "LOAD_BILANS_PERIMETERS_SUCCESS";
export const LOAD_BILANS_FAILURE = "LOAD_BILANS_FAILURE";

export const ADD_PROJECT_ENERGY = "ADD_PROJECT_ENERGY";
export const ADD_PROJECT_ENERGY_SUCCESS = "ADD_PROJECT_ENERGY_SUCCESS";
export const ADD_PROJECT_ENERGY_FAILURE = "ADD_PROJECT_ENERGY_FAILURE";

export const EDIT_PROJECT_ENERGY = "EDIT_PROJECT_ENERGY";

export const DELETE_PROJECT_ENERGY = "DELETE_PROJECT_ENERGY";
export const DELETE_PROJECT_ENERGY_SUCCESS = "DELETE_PROJECT_ENERGY_SUCCESS";
export const DELETE_PROJECT_ENERGY_FAILURE = "DELETE_PROJECT_ENERGY_FAILURE";
// Manual Variable

export const LOAD_MANUAL_VARIABLE = "LOAD_MANUAL_VARIABLE";
export const LOAD_MANUAL_VARIABLE_SUCCESS = "LOAD_MANUAL_VARIABLE_SUCCESS";
export const LOAD_MANUAL_VARIABLE_FAILURE = "LOAD_MANUAL_VARIABLE_FAILURE";

export const ADD_MANUAL_VARIABLE = "ADD_MANUAL_VARIABLE";
export const ADD_MANUAL_VARIABLE_SUCCESS = "ADD_MANUAL_VARIABLE_SUCCESS";
export const ADD_MANUAL_VARIABLE_FAILURE = "ADD_MANUAL_VARIABLE_FAILURE";

export const EDIT_MANUAL_VARIABLE = "EDIT_MANUAL_VARIABLE";
export const EDIT_MANUAL_VARIABLE_SUCCESS = "EDIT_MANUAL_VARIABLE_SUCCESS";
export const EDIT_MANUAL_VARIABLE_FAILURE = "EDIT_MANUAL_VARIABLE_FAILURE";

export const CLEAR_MANUAL_VARIABLE = "CLEAR_MANUAL_VARIABLE";

// VariableData

export const LOAD_VARIABLE_DATA = "LOAD_VARIABLE_DATA";
export const LOAD_VARIABLE_DATA_SUCCESS = "LOAD_VARIABLE_DATA_SUCCESS";
export const LOAD_VARIABLE_DATA_FAILURE = "LOAD_VARIABLE_DATA_FAILURE";
export const RESET_VARIABLE_DATA = "RESET_VARIABLE_DATA";

// Variables
export const INIT_PROJECT_VARIABLES = "INIT_PROJECT_VARIABLES";
export const LOAD_PROJECT_VARIABLES = "LOAD_PROJECT_VARIABLES";
export const LOAD_PROJECT_VARIABLES_LOADING = "LOAD_PROJECT_VARIABLES_LOADING";
export const LOAD_PROJECT_VARIABLES_END_LOADING =
  "LOAD_PROJECT_VARIABLES_END_LOADING";
export const LOAD_PROJECT_VARIABLES_SUCCESS = "LOAD_PROJECT_VARIABLES_SUCCESS";
export const LOAD_PROJECT_VARIABLES_FAILURE = "LOAD_PROJECT_VARIABLES_FAILURE";

export const LOAD_VARIABLES_BY_PROJECT_ID = "LOAD_VARIABLES_BY_PROJECT_ID";
export const LOAD_VARIABLES_BY_PROJECT_ID_SUCCESS =
  "LOAD_VARIABLES_BY_PROJECT_ID_SUCCESS";
export const LOAD_VARIABLES_BY_PROJECT_ID_FAILURE =
  "LOAD_VARIABLES_BY_PROJECT_ID_FAILURE";

export const mutations: MutationTree<ParameterState> = {
  // ROLES
  [LOAD_ROLES](state: ParameterState) {
    state.roles = { ...state.roles, loading: true, error: null };
  },
  [LOAD_ROLES_SUCCESS](state: ParameterState, data: any) {
    state.roles = {
      data: data.roles,
      count: data.count,
      loading: false,
      error: null,
    };
  },
  [LOAD_ROLES_FAILURE](state: ParameterState, error: string) {
    state.roles = { ...state.roles, loading: false, error: error };
  },

  [UPDATE_ROLES](state: ParameterState) {
    state.roles = { ...state.roles, loading: true, error: null };
  },
  [UPDATE_ROLES_SUCCESS](state: ParameterState, role: any) {
    state.roles = {
      ...state.roles,
      loading: false,
      error: null,
    };

    state.roles.data[
      state.roles.data.findIndex((storeRole: any) => storeRole.id === role.id)
    ] = { ...role };
  },
  [UPDATE_ROLES_FAILURE](state: ParameterState, error: string) {
    state.roles = { ...state.roles, loading: false, error: error };
  },

  // PERMISSIONS
  [LOAD_PERMISSIONS](state: ParameterState) {
    state.permissions = { ...state.permissions, loading: true, error: null };
  },
  [LOAD_PERMISSIONS_SUCCESS](state: ParameterState, data: any) {
    state.permissions = {
      data: data.permissions,
      count: data.count,
      loading: false,
      error: null,
    };
  },
  [LOAD_PERMISSIONS_FAILURE](state: ParameterState, error: string) {
    state.permissions = { ...state.permissions, loading: false, error: error };
  },

  // USERS
  [LOAD_USERS](state: ParameterState) {
    state.users = { ...state.users, loading: true, error: null };
  },
  [LOAD_USERS_SUCCESS](state: ParameterState, users: User[]) {
    state.users = { data: users, loading: false, error: null };
  },
  [LOAD_USERS_FAILURE](state: ParameterState, error: string) {
    state.users = { ...state.users, loading: false, error: error };
  },
  [ADD_USER_SUCCESS](state: ParameterState, user: User) {
    state.users = {
      data: [...state.users.data, user],
      loading: false,
      error: null,
    };
  },
  [UPDATE_ONE_USER_SUCCESS](state: ParameterState, updatedUser: User) {
    state.users = {
      data: state.users.data.map((user) =>
        user.id === updatedUser.id ? updatedUser : user,
      ),
      loading: false,
      error: null,
    };
  },
  [DELETE_USER_SUCCESS](state: ParameterState, userId: any) {
    state.users = {
      data: state.users.data.filter((user) => user.id !== userId),
      loading: false,
      error: null,
    };
  },
  [ADD_USER_FAILURE](state: ParameterState, error: string) {
    state.users = { ...state.users, error: error };
  },
  [UPDATE_ONE_USER_FAILURE](state: ParameterState, error: string) {
    state.users = { ...state.users, error: error };
  },
  [DELETE_USER_FAILURE](state: ParameterState, error: string) {
    state.users = { ...state.users, error: error };
  },
  // USER
  [LOAD_USER](state: ParameterState) {
    state.user = { ...state.user, loading: true, error: null };
  },
  [LOAD_USER_SUCCESS](state: ParameterState, user: User) {
    state.user = { data: user, loading: false, error: null };
  },
  [LOAD_USER_FAILURE](state: ParameterState, error: string) {
    state.user = { ...state.user, loading: false, error: error };
  },

  // CLIENTS
  [LOAD_CLIENTS](state: ParameterState) {
    state.clients = { ...state.clients, loading: true, error: null };
  },
  [LOAD_CLIENTS_SUCCESS](state: ParameterState, clients: Client[]) {
    state.clients = { data: clients, loading: false, error: null };
  },
  [LOAD_CLIENTS_FAILURE](state: ParameterState, error: string) {
    state.clients = { ...state.clients, loading: false, error: error };
  },

  // CLIENT
  [LOAD_CLIENT](state: ParameterState) {
    state.client = { ...state.client, loading: true, error: null };
  },
  [LOAD_CLIENT_SUCCESS](state: ParameterState, client: Client) {
    state.client = { data: client, loading: false, error: null };
  },
  [LOAD_CLIENT_FAILURE](state: ParameterState, error: string) {
    state.client = { ...state.client, loading: false, error: error };
  },

  // PROJECTS
  [LOAD_ALL_PROJECTS](state: ParameterState) {
    state.allProjects = { ...state.allProjects, loading: true, error: null };
  },
  [LOAD_ALL_PROJECTS_SUCCESS](state: ParameterState, allProjects: Project[]) {
    state.allProjects = { data: allProjects, loading: false, error: null };
  },
  [LOAD_ALL_PROJECTS_FAILURE](state: ParameterState, error: string) {
    state.allProjects = { ...state.allProjects, loading: false, error: error };
  },

  [LOAD_PROJECTS](state: ParameterState) {
    state.projects = { ...state.projects, loading: true, error: null };
  },
  [LOAD_PROJECTS_SUCCESS](state: ParameterState, projects: Project[]) {
    state.projects = { data: projects, loading: false, error: null };
  },
  [LOAD_PROJECTS_FAILURE](state: ParameterState, error: string) {
    state.projects = { ...state.projects, loading: false, error: error };
  },

  [LOAD_PROJECT](state: ParameterState) {
    state.project = { ...state.project, loading: true, error: null };
  },
  [LOAD_PROJECT_SUCCESS](state: ParameterState, project: Project) {
    state.project = { data: project, loading: false, error: null };
  },
  [LOAD_PROJECT_FAILURE](state: ParameterState, error: string) {
    state.project = { ...state.project, loading: false, error: error };
  },

  [ADD_PROJECT](state: ParameterState) {
    state.projects = { ...state.projects, loading: true, error: null };
  },
  [ADD_PROJECT_SUCCESS](state: ParameterState, project: Project) {
    state.projects = {
      data: [...state.projects.data, project],
      loading: false,
      error: null,
    };
  },
  [ADD_PROJECT_FAILURE](state: ParameterState, error: string) {
    state.projects = { ...state.projects, loading: false, error: error };
  },

  [EDIT_PROJECT](state: ParameterState) {
    state.project = { ...state.project, loading: true, error: null };
  },
  [EDIT_PROJECT_SUCCESS](state: ParameterState, updatedProject: Project) {
    state.project = { data: updatedProject, loading: false, error: null };
  },
  [EDIT_PROJECT_FAILURE](state: ParameterState, error: string) {
    state.project = { ...state.project, loading: false, error: error };
  },

  // BILANS
  [LOAD_BILANS](state: ParameterState) {
    state.bilans = { ...state.bilans, loading: true, error: null };
  },
  [LOAD_BILANS_SUCCESS](
    state: ParameterState,
    { bilans, isRefresh = false }: { bilans: any; isRefresh: boolean },
  ) {
    if (!isRefresh) {
      state.bilans = {
        data: [...state.bilans.data, bilans],
        loading: false,
        error: null,
      };
    } else {
      state.bilans = {
        data: state.bilans.data.map((existingBilan: any) =>
          existingBilan.project_id === bilans.project_id
            ? bilans
            : existingBilan,
        ),
        loading: false,
        error: null,
      };
    }
  },
  [LOAD_BILANS_PERIMETERS_SUCCESS](
    state: ParameterState,
    { bilan, projectId }: { bilan: any; projectId: any },
  ) {
    state.bilans = {
      data: state.bilans.data.map((existingBilan: any) => {
        if (existingBilan.project_id === projectId) {
          console.log(bilan, existingBilan);
          return existingBilan.balanceAapes.map((balance: any) =>
            balance.year == bilan.year ? bilan : balance,
          );
        }

        return existingBilan;
      }),
      loading: false,
      error: null,
    };
  },
  [LOAD_BILANS_FAILURE](state: ParameterState, error: string) {
    state.bilans = { ...state.bilans, loading: false, error: error };
  },

  [DELETE_BILAN](state: ParameterState) {
    state.bilans = { ...state.bilans, loading: true, error: null };
  },
  [DELETE_BILAN_SUCCESS](
    state: ParameterState,
    { projectId, year }: { projectId: string; year: number },
  ) {
    state.bilans = {
      data: state.bilans.data.map((bilan: any) => {
        if (bilan.project_id === projectId) {
          bilan.balanceAapes = bilan.balanceAapes.filter(
            (bAape: any) => bAape.year !== year,
          );
        }
        return bilan;
      }),
      loading: false,
      error: null,
    };
  },
  [DELETE_BILAN_FAILURE](state: ParameterState, error: string) {
    state.bilans = { ...state.bilans, loading: false, error: error };
  },
  // BEX SUPPORT
  [LOAD_BEX_SUPPORT](state: ParameterState) {
    state.bexSupport = { ...state.bexSupport, loading: true, error: null };
  },
  [LOAD_BEX_SUPPORT_SUCCESS](
    state: ParameterState,
    {
      bexSupport,
      project_id,
    }: { bexSupport: any; project_id: string; isRerfresh: boolean },
  ) {
    const exists = state.bexSupport.data.some(
      (item: any) => item.project_id === project_id,
    );

    if (exists) {
      state.bexSupport = {
        data: state.bexSupport.data.map((item: any) =>
          item.project_id === project_id ? { ...bexSupport, project_id } : item,
        ),
        loading: false,
        error: null,
      };
    } else {
      state.bexSupport = {
        data: [...state.bexSupport.data, { ...bexSupport, project_id }],
        loading: false,
        error: null,
      };
    }
  },
  [LOAD_BEX_SUPPORT_FAILURE](state: ParameterState, error: string) {
    state.bexSupport = { ...state.bexSupport, loading: false, error: error };
  },

  // BexSupport Files
  [LOAD_BEX_SUPPORT_FILES](state: ParameterState) {
    state.bexSupportFiles = {
      ...state.bexSupportFiles,
      loading: true,
      error: null,
    };
  },
  [LOAD_BEX_SUPPORT_FILES_SUCCESS](
    state: ParameterState,
    {
      bexSupportFiles,
      project_id,
    }: { bexSupportFiles: any; project_id: string },
  ) {
    if (state.bexSupportFiles.data.length == 0) {
      state.bexSupportFiles = {
        data: [
          ...state.bexSupportFiles.data,
          { ...bexSupportFiles, project_id: project_id },
        ],
        loading: false,
        error: null,
      };
    } else {
      state.bexSupportFiles = {
        data: state.bexSupportFiles.data.map((existingBexSupport: any) =>
          existingBexSupport.project_id === bexSupportFiles.project_id
            ? bexSupportFiles
            : existingBexSupport,
        ),
        loading: false,
        error: null,
      };
    }
  },
  [LOAD_BEX_SUPPORT_FILES_FAILURE](state: ParameterState, error: string) {
    state.bexSupportFiles = {
      ...state.bexSupportFiles,
      loading: false,
      error: error,
    };
  },
  // Be support  choicess
  [LOAD_CHOICES_BEX_SUPPORT](state: ParameterState) {
    state.bexChoices = { ...state.bexChoices, loading: true, error: null };
  },
  [LOAD_CHOICES_BEX_SUPPORT_SUCCESS](state: ParameterState, bexChoices: any[]) {
    state.bexChoices = { data: bexChoices, loading: false, error: null };
  },
  [LOAD_CHOICES_BEX_SUPPORT_FAILURE](state: ParameterState, error: string) {
    state.bexChoices = { ...state.bexChoices, loading: false, error: error };
  },

  // PROJECT ENERGY
  [LOAD_PROJECT_ENERGIES](state: ParameterState) {
    state.projectEnergy = {
      ...state.projectEnergy,
      loading: true,
      error: null,
    };
  },
  [LOAD_PROJECT_ENERGIES_SUCCESS](
    state: ParameterState,
    projectEnergy: ProjectEnergy[],
  ) {
    state.projectEnergy = { data: projectEnergy, loading: false, error: null };
  },
  [LOAD_PROJECT_ENERGIES_FAILURE](state: ParameterState, error: string) {
    state.projectEnergy = {
      ...state.projectEnergy,
      loading: false,
      error: error,
    };
  },

  [ADD_PROJECT_ENERGY](state: ParameterState) {
    state.projectEnergy = {
      ...state.projectEnergy,
      loading: true,
      error: null,
    };
  },
  [ADD_PROJECT_ENERGY_SUCCESS](
    state: ParameterState,
    projectEnergy: ProjectEnergy,
  ) {
    state.projectEnergy = {
      data: [...state.projectEnergy.data, projectEnergy],
      loading: false,
      error: null,
    };
  },
  [ADD_PROJECT_ENERGY_FAILURE](state: ParameterState, error: string) {
    state.projectEnergy = {
      ...state.projectEnergy,
      loading: false,
      error: error,
    };
  },

  [EDIT_PROJECT_ENERGY](state: ParameterState) {
    state.projectEnergy = {
      ...state.projectEnergy,
      loading: true,
      error: null,
    };
  },

  [DELETE_PROJECT_ENERGY](state: ParameterState) {
    state.projectEnergy = {
      ...state.projectEnergy,
      loading: true,
      error: null,
    };
  },
  [DELETE_PROJECT_ENERGY_SUCCESS](state: ParameterState, projectenergy: any) {
    state.projectEnergy = {
      data: [...state.projectEnergy.data].filter(
        (energy: any) => energy.id !== projectenergy.id,
      ),
      loading: false,
      error: null,
    };
  },
  [DELETE_PROJECT_ENERGY_FAILURE](state: ParameterState, error: string) {
    state.projectEnergy = {
      ...state.projectEnergy,
      loading: false,
      error: error,
    };
  },
  // UPDATE CLIENT
  [UPDATE_CLIENT](state: ParameterState) {
    state.clients = { ...state.clients, loading: true, error: null };
  },
  [UPDATE_CLIENT_SUCCESS](state: ParameterState, updateClient: Client) {
    state.client = { data: updateClient, loading: false, error: null };
  },
  [UPDATE_CLIENT_FAILURE](state: ParameterState, error: string) {
    state.client = { ...state.client, loading: false, error: error };
  },

  // PLACES
  [LOAD_PLACES](state: ParameterState) {
    state.places = { ...state.places, loading: true, error: null };
  },
  [LOAD_PLACES_SUCCESS](state: ParameterState, places: Place[]) {
    state.places = { data: places, loading: false, error: null };
  },
  [LOAD_PLACES_FAILURE](state: ParameterState, error: string) {
    state.places = { ...state.places, loading: false, error: error };
  },
  // PLACE
  [LOAD_PLACE](state: ParameterState) {
    state.place = { ...state.place, loading: true, error: null };
  },
  [LOAD_PLACE_SUCCESS](state: ParameterState, place: Place) {
    state.place = { data: place, loading: false, error: null };
  },
  [LOAD_PLACE_FAILURE](state: ParameterState, error: string) {
    state.place = { ...state.place, loading: false, error: error };
  },

  // VARIABLE RELATION
  [LOAD_VARIABLE_RELATION](state: ParameterState) {
    state.variableRelation = {
      ...state.variableRelation,
      loading: true,
      error: null,
    };
  },
  [LOAD_VARIABLE_RELATION_SUCCESS](
    state: ParameterState,
    variableRelation: any,
  ) {
    state.variableRelation = {
      data: variableRelation,
      loading: false,
      error: null,
    };
  },
  [LOAD_VARIABLE_RELATION_FAILURE](state: ParameterState, error: string) {
    state.variableRelation = {
      ...state.variableRelation,
      loading: false,
      error: error,
    };
  },

  // UPDATE PLACE
  [UPDATE_PLACE](state: ParameterState) {
    state.places = { ...state.places, loading: true, error: null };
  },
  [UPDATE_PLACE_SUCCESS](state: ParameterState, placeUpdate: Place) {
    state.place = { data: placeUpdate, loading: false, error: null };
  },
  [UPDATE_PLACE_FAILURE](state: ParameterState, error: string) {
    state.place = { ...state.place, loading: false, error: error };
  },

  // Variables
  [LOAD_VARIABLES](state: ParameterState) {
    state.variables = { ...state.variables, loading: true, error: null };
  },
  [LOAD_VARIABLES_SUCCESS](state: ParameterState, data: any) {
    state.variables = {
      data: data.variables,
      count: data.count,
      loading: false,
      error: null,
    };
  },
  [LOAD_VARIABLES_FAILURE](state: ParameterState, error: string) {
    state.variables = { ...state.variables, loading: false, error: error };
  },

  // Manual Variable
  [LOAD_MANUAL_VARIABLE](state: ParameterState) {
    state.manualVariable = {
      ...state.manualVariable,
      loading: true,
      error: null,
    };
  },
  [LOAD_MANUAL_VARIABLE_SUCCESS](
    state: ParameterState,
    manualVariable: Variable,
  ) {
    state.manualVariable = {
      data: manualVariable,
      loading: false,
      error: null,
    };
  },
  [LOAD_MANUAL_VARIABLE_FAILURE](state: ParameterState, error: string) {
    state.manualVariable = {
      ...state.manualVariable,
      loading: false,
      error: error,
    };
  },

  [ADD_MANUAL_VARIABLE](state: ParameterState) {
    state.manualVariable = {
      ...state.manualVariable,
      loading: true,
      error: null,
    };
  },
  [ADD_MANUAL_VARIABLE_SUCCESS](
    state: ParameterState,
    manualVariable: Variable,
  ) {
    state.manualVariable = {
      data: manualVariable,
      loading: false,
      error: null,
    };
  },
  [ADD_MANUAL_VARIABLE_FAILURE](state: ParameterState, error: string) {
    state.manualVariable = {
      ...state.manualVariable,
      loading: false,
      error: error,
    };
  },

  [EDIT_MANUAL_VARIABLE](state: ParameterState) {
    state.manualVariable = {
      ...state.manualVariable,
      loading: true,
      error: null,
    };
  },
  [EDIT_MANUAL_VARIABLE_SUCCESS](
    state: ParameterState,
    manualVariable: Variable,
  ) {
    state.manualVariable = {
      data: manualVariable,
      loading: false,
      error: null,
    };
  },
  [EDIT_MANUAL_VARIABLE_FAILURE](state: ParameterState, error: string) {
    state.manualVariable = {
      ...state.manualVariable,
      loading: false,
      error: error,
    };
  },

  [UPDATE_USER](state: ParameterState) {
    state.user = { ...state.user, loading: true, error: null };
  },
  [UPDATE_USER_SUCCESS](state: ParameterState, user: User) {
    state.user = { data: user, loading: false, error: null };
  },
  [UPDATE_USER_FAILURE](state: ParameterState, error: string) {
    state.user = { ...state.user, loading: false, error: error };
  },

  [CLEAR_MANUAL_VARIABLE](state: ParameterState) {
    state.manualVariable = {
      data: [] as any,
      loading: false,
      error: null,
    };
  },

  // PROJECT ENERGY
  [LOAD_CHOICES](state: ParameterState) {
    state.choices = { ...state.choices, loading: true, error: null };
  },
  [LOAD_CHOICES_SUCCESS](state: ParameterState, choices: any[]) {
    state.choices = { data: choices, loading: false, error: null };
  },
  [LOAD_CHOICES_FAILURE](state: ParameterState, error: string) {
    state.choices = { ...state.choices, loading: false, error: error };
  },

  // AAPES
  [LOAD_AAPES](state: ParameterState) {
    state.aapes = { ...state.aapes, loading: true, error: null };
  },
  [LOAD_AAPES_SUCCESS](state: ParameterState, aapes: any[]) {
    state.aapes = { data: aapes, loading: false, error: null };
  },
  [LOAD_AAPES_FAILURE](state: ParameterState, error: string) {
    state.aapes = { ...state.aapes, loading: false, error: error };
  },

  [LOAD_AAPES_DETAIL_SUCCESS](state: ParameterState, aape: any) {
    let newDetailsData =
      state.aapes.dataWithDetails && state.aapes.dataWithDetails.length > 0
        ? state.aapes.dataWithDetails
        : [];

    if (
      newDetailsData.length > 0 &&
      newDetailsData.find((aap: any) => aap.id == aape.id)
    ) {
      newDetailsData = newDetailsData.map((app: any) =>
        app.id == aape.id ? aape : { ...aape, ...app },
      );
    } else {
      newDetailsData.push(aape);
    }
    //   newDetailsData.push(aape);
    state.aapes = {
      ...state.aapes,
      loading: false,
      error: null,
      dataWithDetails: [...newDetailsData],
    };
  },
  [LOAD_AAPES_DETAIL_FAILURE](state: ParameterState, error: string) {
    state.aapes = { ...state.aapes, loading: false, error: error };
  },

  [ADD_AAPE](state: ParameterState) {
    state.aapes = { ...state.aapes, loading: true, error: null };
  },
  [ADD_AAPE_SUCCESS](state: ParameterState, aape: any) {
    state.aapes = {
      data: [...state.aapes.data, aape],
      loading: false,
      error: null,
    };
  },
  [ADD_AAPE_FAILURE](state: ParameterState, error: string) {
    state.aapes = { ...state.aapes, loading: false, error: error };
  },

  [EDIT_AAPE](state: ParameterState) {
    state.aapes = { ...state.aapes, loading: true, error: null };
  },
  [EDIT_AAPE_SUCCESS](state: ParameterState, aape: any) {
    state.aapes.loading = false;
    state.aapes.error = null;
    const aapeIndex = state.aapes.data.findIndex(
      (aapeData: any) => aapeData.id === aape.id,
    );
    state.aapes.data[aapeIndex] = aape;
    state.aapes.data = JSON.parse(JSON.stringify(state.aapes.data));
  },
  [EDIT_AAPE_FAILURE](state: ParameterState, error: string) {
    state.aapes = { ...state.aapes, loading: false, error: error };
  },

  [DELETE_AAPE](state: ParameterState) {
    state.aapes = { ...state.aapes, loading: true, error: null };
  },
  [DELETE_AAPE_SUCCESS](state: ParameterState, aape: any) {
    state.aapes = {
      data: [...state.aapes.data].filter(
        (aapeData: any) => aapeData.id !== aape.id,
      ),
      loading: false,
      error: null,
    };
  },
  [DELETE_AAPE_FAILURE](state: ParameterState, error: string) {
    state.aapes = { ...state.aapes, loading: false, error: error };
  },

  [CLEAR_AAPES](state: ParameterState) {
    state.aapes = { data: [], loading: false, error: null };
  },

  // PERIMETER
  [LOAD_PERIMETERS](state: ParameterState) {
    state.perimetres = { ...state.aapes, loading: true, error: null };
  },
  [LOAD_PERIMETERS_SUCCESS](state: ParameterState, perimetres: any[]) {
    state.perimetres = { data: perimetres, loading: false, error: null };
  },
  [LOAD_PERIMETERS_FAILURE](state: ParameterState, error: string) {
    state.perimetres = { ...state.perimetres, loading: false, error: error };
  },

  [ADD_PERIMETER](state: ParameterState) {
    state.perimetres = { ...state.perimetres, loading: true, error: null };
  },
  [ADD_PERIMETER_SUCCESS](state: ParameterState, perimetre: any) {
    state.perimetres = {
      data: [...state.perimetres.data, perimetre],
      loading: false,
      error: null,
    };
  },
  [ADD_PERIMETER_FAILURE](state: ParameterState, error: string) {
    state.perimetres = { ...state.perimetres, loading: false, error: error };
  },

  [EDIT_PERIMETER](state: ParameterState) {
    state.perimetres = { ...state.perimetres, loading: true, error: null };
  },
  [EDIT_PERIMETER_SUCCESS](state: ParameterState, perimetre: any) {
    state.perimetres.loading = false;
    state.perimetres.error = null;
    const perimetreIndex = state.perimetres.data.findIndex(
      (perimetreData: any) => perimetreData.id === perimetre.id,
    );
    state.perimetres.data[perimetreIndex] = perimetre;
    state.perimetres.data = JSON.parse(JSON.stringify(state.perimetres.data));
  },
  [EDIT_PERIMETER_FAILURE](state: ParameterState, error: string) {
    state.perimetres = { ...state.perimetres, loading: false, error: error };
  },

  [DELETE_PERIMETER](state: ParameterState) {
    state.perimetres = { ...state.perimetres, loading: true, error: null };
  },
  [DELETE_PERIMETER_SUCCESS](state: ParameterState, perimetre: any) {
    state.perimetres = {
      data: [...state.perimetres.data].filter(
        (perimetreData: any) => perimetreData.id !== perimetre.id,
      ),
      loading: false,
      error: null,
    };
  },
  [DELETE_PERIMETER_FAILURE](state: ParameterState, error: string) {
    state.perimetres = { ...state.perimetres, loading: false, error: error };
  },

  [CLEAR_PERIMETERS](state: ParameterState) {
    state.aapes = { data: [], loading: false, error: null };
  },

  // Variable
  [LOAD_VARIABLE](state: ParameterState) {
    state.variable = { ...state.variable, loading: true, error: null };
  },
  [LOAD_VARIABLE_SUCCESS](state: ParameterState, variable: Variable) {
    state.variable = { data: variable, loading: false, error: null };
  },
  [LOAD_VARIABLE_FAILURE](state: ParameterState, error: string) {
    state.variable = { ...state.variable, loading: false, error: error };
  },
  [CLEAR_VARIABLE](state: ParameterState) {
    state.variable = {
      data: [] as any,
      error: null,
      loading: false,
    };
  },

  // Variable Data
  [LOAD_VARIABLE_DATA](state: ParameterState) {
    state.variableDatas = {
      ...state.variableDatas,
      loading: true,
      error: null,
    };
  },
  [LOAD_VARIABLE_DATA_SUCCESS](state: ParameterState, variableDatas: any) {
    state.variableDatas = { data: variableDatas, loading: false, error: null };
  },
  [LOAD_VARIABLE_DATA_FAILURE](state: ParameterState, error: string) {
    state.variableDatas = {
      ...state.variableDatas,
      loading: false,
      error: error,
    };
  },
  [RESET_VARIABLE_DATA](state: ParameterState) {
    state.variableDatas = {
      data: [],
      error: null,
      loading: false,
    };
  },

  // Edit Variable
  [EDIT_VARIABLE](state: ParameterState) {
    state.variable = { ...state.variable, loading: true, error: null };
  },
  [EDIT_VARIABLE_SUCCESS](state: ParameterState, updatedVariable: Variable) {
    state.variable = { data: updatedVariable, loading: false, error: null };
  },
  [EDIT_VARIABLE_FAILURE](state: ParameterState, error: string) {
    state.variable = { ...state.variable, loading: false, error: error };
  },

  // Project Variables

  [INIT_PROJECT_VARIABLES](state: ParameterState) {
    state.projectsVariables = [];
  },

  [LOAD_PROJECT_VARIABLES_LOADING](state: ParameterState) {
    state.variablesByProject = {
      ...state.variablesByProject,
      loading: true,
      error: null,
    };
  },
  [LOAD_PROJECT_VARIABLES_END_LOADING](state: ParameterState) {
    state.variablesByProject = {
      ...state.variablesByProject,
      loading: false,
      error: null,
    };
  },

  [LOAD_PROJECT_VARIABLES](state: ParameterState, newDevice: any) {
    const deviceIndex = state.projectsVariables.findIndex(
      (device: any) => device.id === newDevice.id,
    );
    if (deviceIndex === -1) {
      state.projectsVariables = [...state.projectsVariables, newDevice];
    }
  },
  [LOAD_PROJECT_VARIABLES_SUCCESS](state: ParameterState, devicedata: any) {
    const deviceIndex = state.projectsVariables.findIndex(
      (device: any) => device.id === devicedata.id,
    );
    state.projectsVariables[deviceIndex] = devicedata;
    state.projectsVariables = JSON.parse(
      JSON.stringify(state.projectsVariables),
    );
  },

  [LOAD_VARIABLES_BY_PROJECT_ID](state: ParameterState) {
    state.variablesByProject = {
      ...state.variablesByProject,
      loading: true,
      error: null,
    };
  },
  [LOAD_VARIABLES_BY_PROJECT_ID_SUCCESS](state: ParameterState, data: any) {
    state.variablesByProject = {
      data: data.variables,
      count: data.count,
      loading: false,
      error: null,
    };
  },
  [LOAD_VARIABLES_BY_PROJECT_ID_FAILURE](state: ParameterState, error: string) {
    state.variablesByProject = {
      ...state.variablesByProject,
      loading: false,
      error: error,
    };
  },
};
